<template>
    <div>
      <div class="card-title h5">3. {{ $t('tabs.academic_data.description') }}</div>
        <div class="col-sm-12 col-md-offset-1 col-md-10">

        <div class="form-group mb-3">
          <label class="form-label required" :class="{'input': true, 'is-invalid': errors.has('estudis_cursats') }">{{ $t('tabs.academic_data.question1') }}</label>
          <div class="form-check" v-for="(estudis, index) in options_estudis_cursats" :key="index">
            <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('estudis_cursats') }"
                   name="estudis_cursats"
                   v-model="estudis_cursats"
                   v-validate="'required|included:' + options_estudis_cursats.map(item => item.value)"
                   :value="estudis.value"
            >
            <label class="form-check-label">{{ estudis[lang] }}</label>
          </div>
          <div v-show="this.estudis_cursats === '6'">
            <span class="invalid-feedback" v-show="errors.has('estudis_cursats')">{{ errors.first('estudis_cursats') }}</span>

              <input type="text" maxlength="80" class="form-control" :class="{'input': true, 'is-invalid': errors.has('estudis_cursats_altres') }"
                     placeholder="Indica els estudis (Altres)"
                     name="estudis_cursats_altres"
                     v-model="estudis_cursats_altres"
                     v-validate="ruleEstudisCursats"
              >
              <span v-show="errors.has('estudis_cursats_altres')" class="invalid-feedback">{{ errors.first('estudis_cursats_altres') }}</span>
            </div>
        </div>

        <div class="form-group mb-3">
          <div class="form-group">
            <label class=" form-label" :class="{'required' : estudis_cursats === '1'}">{{ $t('tabs.academic_data.question2') }}:</label>
            <select class="form-select" :class="{'input': true, 'is-invalid': errors.has('tipus_batxillerat') }"
                    data-placeholder="Selecciona un tipus"
                    name="tipus_batxillerat"
                    v-model="tipus_batxillerat"
                    v-validate="ruleTipusEstudisCursats"
            >
              <option></option>
              <option v-for="(tipus, id) in options_tipus_batxillerat" :value="tipus.value" :key="id">{{ tipus[lang]}}</option>
            </select>
            <span class="invalid-feedback" v-show="errors.has('tipus_batxillerat')">{{ errors.first('tipus_batxillerat') }}</span>
          </div>
        </div>

        <div class="form-group mb-3">
            <label class="required form-label">{{ $t('tabs.academic_data.question3') }}</label>
            <input type="text" class="form-control required"  :class="{'input': true, 'is-invalid': errors.has('centre_academic_ultims_estudis') }"
                   name="centre_academic_ultims_estudis"
                   v-model="centre_academic_ultims_estudis"
                   v-validate="'required'"
                   placeholder="Ex. Santa Anna Mataró"
            >
            <span class="invalid-feedback" v-show="errors.has('centre_academic_ultims_estudis')">{{ errors.first('centre_academic_ultims_estudis') }}</span>
        </div>

        </div>
    </div>

</template>

<script>
import {list_estudis_cursats, list_tipus_batxillerat} from "@/helpers/data";
//import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
 name: 'dades-academiques',
  props: { lang: { required:true, default:'ca'} },
  //components: {ValidationObserver, ValidationProvider },
  data() {
    return {
      estudis_cursats : '',
      tipus_batxillerat: '',
      estudis_cursats_altres: '',
      centre_academic_ultims_estudis: '',
      options_estudis_cursats: list_estudis_cursats,
      options_tipus_batxillerat: list_tipus_batxillerat
    }
  },
  created() {
    this.$validator.localize(this.lang);
    this.$i18n.locale = this.lang;
  },
  computed: {
    ruleEstudisCursats() {
      return this.estudis_cursats && this.estudis_cursats === '6' ? 'required' : '';
    },
    ruleTipusEstudisCursats(){
      return this.estudis_cursats && this.estudis_cursats === '1' ? 'required' : '';
    }
  },
 methods: {
   async validate() {
     const result = await this.$validator.validateAll();
     if (!result) {
       return false;
     }
     this.$emit('on-validate', this.$data, true);
     return result;
   }
}}
</script>
